
// Label name 
export const nameStyle = {
    fontWeight: "bold",
    fontStyle: "italic",
    textTransform: "capitalize"
}

// Current Temperature grid
export const tempGridStyle = {
    flexGrow: 1,
    height: "50px",
    overflow: "hidden",
    padding: "0 5px"
}


// Weekly panel title
export const panelTitleStyle = {
    color: "#fff",
    position: "absolute",
    top: "50%",
    left: "50%",
    zIndex: 1,
    transform: "translateX(-50%) translateY(-50%)",
    width: "100%",
}

// City name in the panel
export const cityNameStyle = {
    color: "#fff",
    letterSpacing: "5px",
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase"
}